export interface IProperties {
  id?: number
  uuid?: string
  project_id?: number

  name: string
  description?: string
  identifier?: string
  latitude?: number
  longitude?: number
  geom_point?: string
  geom_polygon?: string
  type_coordinates?: string
  geom_line?: string
  indirect_profit_rate?: string
  address?: {
    zip_code?: string
    street_name?: string
    number?: number
    complement?: string
    district?: string
    city?: string
    state?: string
  }

  type_geometry?: string
  field_id?: []
  regularized?: boolean

  should_have_participation?: 'yes' | 'no'
  project?: {
    id: number
    code: string
    description: string
  }

  enterprises?: [
    {
      id?: number
      name?: string
      text?: string
      enterprise_type: {
        description?: string
      }
    }
  ]
  fields?: [
    {
      id?: number
      name?: string
    }
  ]
  activity_log?: [
    {
      properties?: {
        attributes?: {
          entrepreneur_id: number
          responsible_id: number
        }
      }
    }
  ]
}
export interface IPropertyParticipations {
  id?: number
  percentage?: string
  uuid?: string
  owner_id?: number
  owner?: {
    id?: number
    name?: string
  }
  property_id?: [
    {
      id?: number
      name?: string
    }
  ]
  beneficiary?: boolean
}

export const propertiesInitValues: IProperties = {
  name: '',
  identifier: '',
  address: {
    zip_code: '',
    street_name: '',
    district: '',
    city: '',
    state: '',
    number: undefined,
  },
}
export const propertyParticipationsInitValues: IPropertyParticipations = {
  percentage: '',
}
